import { ActionTree } from 'vuex';
import { LiveState } from './types';
import { RootState } from '../types';

const actions: ActionTree<LiveState, RootState> = {};

export default actions;
